<div class="open-house" *ngIf="listing.hasOpenHouse && listing.openHouses.length && !listing.isCommercial"
[class.residential]="!listing.isLuxury"
[class.luxury]="listing.isLuxury" [class.has-more-info]="listing.openHouses[0].information">
  <div class="details">
    <div class="summary">
      <h4 class="title" translate="open-house.open-house"></h4>
      <ng-container *ngIf="listing.isLuxury">
        <p class="address">{{listing.address}}</p>
        <div class="horizontal-divider"></div>
      </ng-container>
    </div>
    <div class="content">
      <div class="open-house-dates">
        <ng-container *ngFor="let openHouse of listing.openHouses; let last = last;">
          <div class="open-house-date" *ngIf="openHouse.active">
            {{openHouse.startTime | date:'MMMM d'}} {{openHouse.timeDescription}}
          </div>
        </ng-container>
      </div>

      <div class="more-info" *ngIf="listing.openHouses[0].information && listing.isLuxury">
        {{listing.openHouses[0].information}}
      </div>

      <a *ngIf="listing.lat && listing.lng" href="https://www.google.com/maps/dir/?api=1&destination={{listing.lat}},{{listing.lng}}"
      target="_blank" rel="noopener" class="directions" [class.btn]="listing.isCommercial || listing.isLuxury" [class.btn-secondary]="listing.isCommercial" [class.btn-fake]="listing.isLuxury">
        <span class="is-flex has-flex-align-center">
            <img *ngIf="!listing.isLuxury" [src]="('/assets/icons/listing-details/pin.svg') | staticp" height="17" width="18"
            [alt]="('listing-summary.get-directions' ) | translate"
            />
          <span translate="open-house.get-directions"></span>
          <i *ngIf="listing.isLuxury" class="material-icons chevron-right">chevron_right</i>
        </span>
      </a>
    </div>
  </div>
  <div *ngIf="listing.openHouses[0].information && !listing.isLuxury" class="more-info">
    <div *ngIf="shouldShowMoreDetails" class="expanded-info">{{listing.openHouses[0].information}}</div>
    <button (click)="shouldShowMoreDetails = !shouldShowMoreDetails" class="btn btn-fake is-flex has-flex-align-center">
      <span [translate]="shouldShowMoreDetails ? 'open-house.see-less' : 'open-house.see-more'"></span>
      <i class="material-icons">{{shouldShowMoreDetails ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
    </button>
  </div>
</div>
